import * as turf from '@turf/turf';
import axios from 'axios';
import * as mgrs from 'mgrs';

import CoordUtils from './CoordUtils';

import { ELEVATION_BASE_URL, GOOGLE_API_KEY, GOOGLE_GEOCODING_URL } from '@/config';

// 거리(m) 획득
export const getDistance = (from, to) => {
  from = CoordUtils.arrayFromObject(from);
  to = CoordUtils.arrayFromObject(to);

  return turf.distance(from, to, { units: 'meters' });
};

// 경로 총 거리(m) 획득
export const getDistanceAlongPath = (path) => {
  if (path.length < 2) return 0;

  const line = turf.lineString(path.map(({ lat, lng }) => [lng, lat]));
  return turf.length(line, { units: 'meters' });
};

// 다각형 면적(㎢) 획득
export const getPolygonArea = (positions) => {
  const coordinates = positions.map((position) => CoordUtils.arrayFromObject(position));
  const polygon = turf.polygon([coordinates]);

  return turf.area(polygon) / 1e6;
};

// 원 면적(㎢) 획득
export const getCircleArea = (radius) => {
  return Math.PI * Math.pow(radius / 1000, 2);
};

// 위치 고도 획득
export const getElevation = async (position) => {
  const { lat, lng } = getValidCoords(position);

  const elevation = await axios
    .get(`${ELEVATION_BASE_URL}/position`, {
      params: { points: `${lat},${lng}` },
    })
    .then(({ data }) => data.data.elevation);

  return elevation;
};

// 경로 고도 획득
export const getElevationAlongPath = async (path) => {
  const points = [];
  path.forEach((position) => {
    const { lat, lng } = getValidCoords(position);
    points.push(lat);
    points.push(lng);
  });

  const elevations = await axios
    .post(`${ELEVATION_BASE_URL}/path`, { points, samples: 1024 })
    .then(({ data }) => data.data.elevations);

  return elevations;
};

// 좌표 → MGRS
export const getMGRS = ({ lat, lng }) => {
  try {
    return mgrs.forward([lng, lat]);
  } catch (error) {
    console.error(error.message);
    return 'OUT OF BOUNDS';
  }
};

// MGRS → 좌표
export const getFromMGRS = (geocode) => {
  try {
    return CoordUtils.objectFromArray(mgrs.toPoint(geocode));
  } catch (error) {
    console.error(error.message);
    return null;
  }
};

// 지오코딩 (주소 → 좌표)
export const geocoding = async ({ address }) => {
  try {
    const result = await axios.get(GOOGLE_GEOCODING_URL, {
      params: {
        key: GOOGLE_API_KEY,
        address: encodeURIComponent(address),
      },
    });
    const { lat, lng } = result.data.results[0].geometry.location;

    return { lat, lng };
  } catch {
    throw new Error('There are no matching addresses.');
  }
};

// GPS 유효 데이터 수신 전 위치 정보
export const isColdPosition = (lat, lng) => {
  return Math.abs(lat) < 1 || Math.abs(lng) < 1;
};

const getValidCoords = ({ lat, lng }) => {
  lat = Math.max(-85, Math.min(lat, 85));
  lng = Math.max(-180, Math.min(lng, 180));

  return { lat, lng };
};
